<template>
  <div class="page valign-wrapper">
    <div id="container-unlink-user" class="container">
      <div class="row" style="text-align: center;">
        <h6>{{ $t("SETTINGS-UNLINK.MSG") }}</h6>
        <a v-on:click="cancel" v-on:keyup.enter="cancel" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{$t("GENERAL.NO")}}</a>
        <a v-on:click="unlink" v-on:keyup.enter="unlink" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{$t("GENERAL.YES")}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router/index'
import Bus from '@/components/ControlBus'
import SpatialNavigation from 'js-spatial-navigation'
const auth = require('@/services/auth.js')

export default {
  name: 'UnlinkUser',
  mounted: function () {
    this.SN = SpatialNavigation.add({ selector: '#container-unlink-user .focusable', restrict: 'self-only' })
    SpatialNavigation.makeFocusable(this.SN)
    SpatialNavigation.focus(this.SN)
    SpatialNavigation.resume()
    // keys control
    Bus.$on('key-back', this.cancel)
  },
  methods: {
    cancel () { this.$router.go(-1) },
    unlink () {
      // token demo user
      auth.getToken(false, false).then(() => {
        auth.getUser().then(response => {
          this.$store.commit('setUser', response.data['results'][0])
          localStorage.removeItem('locale-demo')
          router.push({name: 'welcome'})
        })
      })
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.cancel)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.container
  padding: 2rem
  border-radius: 2px
  color: #424242

  h6
    font-size: 2.6rem
</style>



// WEBPACK FOOTER //
// src/pages/settings/UnlinkUser.vue